import {
  ANALYTICS_OPT_OUT_STORAGE_KEY,
  GA_COOKIE_NAME_PATTERN,
} from './analytics.constants'

const optOutListeners = new Set<() => void>()

export function isAnalyticsOptedOut(): boolean {
  return localStorage.getItem(ANALYTICS_OPT_OUT_STORAGE_KEY) === 'true'
}

export function storeAnalyticsOptOut(isOptedOut: boolean): void {
  if (isOptedOut) {
    localStorage.setItem(ANALYTICS_OPT_OUT_STORAGE_KEY, 'true')
  } else {
    localStorage.removeItem(ANALYTICS_OPT_OUT_STORAGE_KEY)
  }
  optOutListeners.forEach((listener) => listener())
}

export function subscribeToAnalyticsOptOut(listener: () => void): () => void {
  optOutListeners.add(listener)
  return () => {
    optOutListeners.delete(listener)
  }
}

export function clearGoogleAnalyticsCookies(): void {
  const cookieNames = document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0]?.trim() ?? '')
    .filter((cookieName) => GA_COOKIE_NAME_PATTERN.test(cookieName))

  const hostLabels = document.location.hostname.split('.')
  const candidateDomains = hostLabels
    .map((_, startIndex) => hostLabels.slice(startIndex).join('.'))
    .filter((domain) => domain.includes('.'))

  for (const cookieName of cookieNames) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    for (const domain of candidateDomains) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`
    }
  }
}
